/**
 * Report Builder JavaScript
 *
 * Manages toolbar initialization and coordinates with chart, FAQ, and text block modules
 */

(function () {
  "use strict";


  let isToolbarInitialized = false;

  /**
   * Initialize the report builder
   */
  function initReportBuilder() {
    // Initialize toolbar (only once)
    if (!isToolbarInitialized) {
      initToolbar();
      isToolbarInitialized = true;
    }

    // Initialize report header editing
    if (window.ReportBuilderUtils && window.ReportBuilderUtils.initReportHeaderEditing) {
      window.ReportBuilderUtils.initReportHeaderEditing();
    }
  }

  /**
   * Initialize toolbar buttons
   */
  function initToolbar() {
    const toolbarButtons = document.querySelectorAll(".toolbar-btn[data-action]");
    
    toolbarButtons.forEach((btn) => {
      // Check if already initialized to prevent duplicate listeners
      if (btn.hasAttribute("data-toolbar-initialized")) {
        return;
      }
      
      // Mark as initialized
      btn.setAttribute("data-toolbar-initialized", "true");
      
      btn.addEventListener("click", function () {
        const action = this.getAttribute("data-action");
        
        if (this.disabled) {
          return;
        }

        switch (action) {
          case "chart":
            // Trigger chart placeholder addition via place-chart.js
            if (window.ReportBuilderChart && window.ReportBuilderChart.addChartPlaceholder) {
              window.ReportBuilderChart.addChartPlaceholder();
            }
            break;
          case "text":
            // Trigger text block addition via existing functionality
            const addTextBtn = document.getElementById("addTextBtn");
            if (addTextBtn) {
              addTextBtn.click();
            }
            break;
          case "title":
            // Place a title via place-title.js
            if (window.ReportBuilderTitle && window.ReportBuilderTitle.addTitle) {
              window.ReportBuilderTitle.addTitle();
            }
            break;
          case "faq":
            // Trigger FAQ placeholder addition
            if (window.ReportBuilderFaq && window.ReportBuilderFaq.addFaqPlaceholder) {
              window.ReportBuilderFaq.addFaqPlaceholder();
            }
            break;
          case "image":
            // Trigger image placeholder addition via place-image.js
            if (window.ReportBuilderImage && window.ReportBuilderImage.addImagePlaceholder) {
              window.ReportBuilderImage.addImagePlaceholder();
            }
            break;
          case "calculation":
            // Trigger calculator placeholder addition via place-calculator.js
            if (window.ReportBuilderCalculator && window.ReportBuilderCalculator.addCalculatorPlaceholder) {
              window.ReportBuilderCalculator.addCalculatorPlaceholder();
            }
            break;
          case "patient-stories":
            // Trigger patient story placeholder addition via place-patient-story.js
            if (window.ReportBuilderPatientStory && window.ReportBuilderPatientStory.addPatientStoryPlaceholder) {
              window.ReportBuilderPatientStory.addPatientStoryPlaceholder();
            }
            break;
          case "health-policy-audit":
            // Place the Health Policy Audit chart via place-health-policy-audit.js
            if (window.ReportBuilderHealthPolicyAudit && window.ReportBuilderHealthPolicyAudit.addHealthPolicyAudit) {
              window.ReportBuilderHealthPolicyAudit.addHealthPolicyAudit();
            }
            break;
          case "page-break":
            // Trigger page break placeholder addition via place-page-break.js
            if (window.ReportBuilderPageBreak && window.ReportBuilderPageBreak.addPageBreakPlaceholder) {
              window.ReportBuilderPageBreak.addPageBreakPlaceholder();
            }
            break;
          case "export-pdf":
            // Trigger PDF export via chart-pdf-export.js
            if (window.ReportBuilderPDFExport && window.ReportBuilderPDFExport.exportToPDF) {
              window.ReportBuilderPDFExport.exportToPDF();
            }
            break;
          case "save-pdf":
            // Trigger PDF save to hospital via chart-pdf-export.js
            if (window.ReportBuilderPDFExport && window.ReportBuilderPDFExport.saveToPDF) {
              window.ReportBuilderPDFExport.saveToPDF();
            }
            break;
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReportBuilder);
  } else {
    initReportBuilder();
  }
})();
